<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5 d-body">
  <div>
    <div class="my-3 d-flex justify-content-between">
      <div class="font20">Learning Paths</div>
      <div>
        <button
          class="btn btn-secondary btn-sm"
          routerLink="/learningPath/create"
        >
          Create Learning Path
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center sm-reverse my-2 table-search-container"
    >
      <div
        class="text-green font12 font-bold col-lg-2 col-md-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
      >
        ADD FILTER
      </div>
      <div class="table-search col-lg-7 col-md-7 col-sm-12">
        <input 
          type="text" 
          placeholder="Search for Learning Paths"
          #query
          (keyup)="filter(query.value)" 
        />
      </div>
      <div class="sort col-lg-3 col-md-3 col-sm-12 sm-mt sm-mb-2 sm-text-center">
        <span class="font-bold font14 text-grey mr-3">SORT BY</span>
        <span class="dropdown click">
          <span
            class="font-bold text-green font12 dropdown-toggle"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            >Name <i class="fa fa-chevron-down"></i
          ></span>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item click line-under" (click)="sortByName()">Name</a>
            <a class="dropdown-item click" (click)="sortByDate()">Date</a>
            <a class="dropdown-item click" (click)="sortByRestriction()">Restriction</a>
            <!-- <a class="dropdown-item click" (click)="sortByCourseLength()">Course Length</a> -->
          </div>
        </span>
      </div>
    </div>
    <div class="my-3 list-view__wrapper">
      <div class="table-responsive">
        <table class="table no-wrap" id="myTable">
          <tbody>
            <tr
              class="my-5"
              *ngFor="
                let learningPath of learningPaths
                  | paginate
                    : {
                        id: 'lp',
                        itemsPerPage: paginationInfo.size,
                        totalItems: paginationInfo.totalElements,
                        currentPage: paginationInfo.number
                      };
                index as i
              "
            >
              <td class="mx-3 no-wrap">
                <div class="mx-2">
                  <div>
                    <h5 class="header mb-0">PLAN NAME</h5>
                    <p class="value mt-1 mb-0">{{ learningPath?.name }} - L2</p>
                  </div>
                </div>
              </td>
              <td>
                <div
                  class="mx-2 d-flex justify-content-around align-items-center"
                >
                  <div class="mx-2">
                    <p class="header mb-0">COURSES</p>
                    <p class="value mt-1 mb-0 d-flex justify-content-center">
                      {{ learningPath?.courses?.length }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <div
                  class="mx-2 d-flex justify-content-around align-items-center"
                >
                  <div class="mx-2">
                    <p class="header mb-0">RESTRICTION</p>
                    <p
                      *ngIf="!learningPath?.restricted"
                      class="value mt-1 mb-0"
                    >
                      All
                    </p>
                    <p *ngIf="learningPath?.restricted" class="value mt-1 mb-0">
                      {{ learningPath?.restriction }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <div
                  class="mx-2 d-flex justify-content-around align-items-center"
                >
                  <div class="mx-2">
                    <p class="header mb-0">DATE ADDED</p>
                    <p class="value mt-1 mb-0">
                      {{ learningPath?.createdAt | date }}
                    </p>
                  </div>
                </div>
              </td>
              <td class="d-flex">
                <button
                  class="btn btn-secondary btn-sm mx-2"
                  [routerLink]="['/learningPath/edit', learningPath?.id]"
                >
                  Edit
                </button>
                <button
                  class="btn btn-outline-secondary btn-sm mx-2"
                  [routerLink]="['/learningPath/view', learningPath?.id]"
                >
                  View
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center sm-flex-column">
        <pagination-controls
          previousLabel="Prev"
          nextLabel="Next"
          responsive="true"
          id="lp"
          class="my-pagination"
        ></pagination-controls>
      </div>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>
